module.exports = __webpack_public_path__ + "static/media/header.2bace9e0.svg";